// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "-legacy." + {"53":"06565e89","125":"1c191577","179":"5a27908e","870":"9d360055"}[chunkId] + ".js";
};